import React, { useEffect, useState } from 'react';
import './CampanaInfo.css';
import { Link, useHistory } from 'react-router-dom';
import { getCampaigns } from '../services/campaigns';
import { getCampanaEspecial } from '../services/campana_especial';
import { executeVote } from '../services/executeVote';
import { confirmAlert } from 'react-confirm-alert';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';
import Carousel from 'react-bootstrap/Carousel';
import 'bootstrap/dist/css/bootstrap.min.css';
import parse from 'html-react-parser';
import HeaderCampana from '../HeaderCampana/HeaderCampana';
import Welcome from '../Welcome/Welcome';
import Quorum from '../Card/Quorum'
import Opcion2 from '../Card/Opcion2'
import Opcion3 from '../Card/Opcion3'
import Opcion4 from '../Card/Opcion4'
import Opcion6 from '../Card/Opcion6'
import { useAuth } from '../AuthContext/AuthContext'
function CampanaInfo() {
  const { dispatch } = useAuth();
  let history = useHistory();
  const [campanaEspecial, setCampanaEspecial] = useState([]);
  const [campaigns, setCampaigns] = useState([]);



  let redirectTransmision = () => {
    history.push("/transmision");
  }

  const trucateText = (text) => {
    let text2 = text;
    const myArray = text.split(".");

    if (myArray.length > 1)
      return parse(myArray[0] + '.');
    else
      return parse(text2);

  }

  let Cargarvotaciones = () => {

    getCampanaEspecial(dispatch.cif, dispatch.token)
      .then(response => {
        console.log(response.body)
        setCampanaEspecial(response.body);
      });

    //Cargar campanas
    getCampaigns(-1, dispatch.token)
      .then(response => {
        setCampaigns(response.body);
      });
  }

  useEffect(() => {
    let mounted = true;
    Cargarvotaciones();
    return () => mounted = false;
  }, [])

  const vote = (candidateId, candidateName, buton, clase) => {
    buton.target.disabled = true;
    executeVote(candidateId, dispatch.cif, dispatch.token)
      .then(result => {
        confirmVote(candidateName, result.body, result.disponible, clase);
      })
  }

  const voteNoConfirm = (candidateId, buton) => {
    buton.target.disabled = true;
    executeVote(candidateId, dispatch.cif, dispatch.token)
      .then(result => {
        redirectTransmision();

      });
  }

  const voteNoConfirm6 = (candidateId, buton, boton2, onClose) => {
    if (buton && buton.target) buton.target.disabled = true;
    if (boton2 && boton2.target) boton2.target.disabled = true;

    executeVote(candidateId, dispatch.cif, dispatch.token);
  }

  const askForVote = (candidateId, candidateName, buton, nombre) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h3>{parse(candidateName)}</h3>
            <div>
              <button className="no-botton button-modal" onClick={onClose}>Regresar</button>
              <button
                className="button-modal"
                onClick={() => {
                  voteNoConfirm(candidateId, buton);
                  onClose();
                }}
              >
                {nombre}
              </button>
            </div>
          </div>
        );
      }
    });
  }

  const askCarusel = () => {
    const images = Array.from({ length: 11 }, (_, index) => `fondos/reformas/Slide${index + 1}.png`);

    confirmAlert({
      customUI: ({ onClose }) => (
        <div className='custom-ui-slide' key="slider" style={{ width: '100%', maxWidth: '1000px', padding: '40px' }}>
          <Carousel>
            {images.map((image, index) => (
              <Carousel.Item key={`slide-${index}`}>
                <img
                  className="d-block w-100"
                  src={image}
                  alt="Reformas"
                  style={{ maxHeight: '70vh', objectFit: 'contain' }}
                />
              </Carousel.Item>
            ))}
          </Carousel>
          <center>
            <button
              className="button-modal"
              onClick={onClose}
              style={{ marginTop: '20px' }}
            >
              Aceptar
            </button>
          </center>
        </div>
      )
    });
  }

  const askForKnow = (candidateId, buton) => {
    buton.target.disabled = true;
    executeVote(candidateId, dispatch.cif, dispatch.token)
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h3>Sí desea aprobar los estados financieros de Cooperativa Guadalupana presiones el botón <b>SI</b>, en caso contrario presione el botón <b>NO</b>.</h3>
            <div>
              <button className="no-botton button-modal"
                onClick={() => {
                  onClose();
                  voteNoConfirm(37, buton);
                  onClose();
                  //redirectTransmision();
                }}
              >
                NO</button>
              <button
                className="button-modal"
                onClick={() => {
                  voteNoConfirm(22, buton);
                  onClose();
                }}
              >
                Si
              </button>
            </div>
          </div>
        );
      }
    });
  }


  const confirmVote = (candidateName, body, available, clase) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        let message;
        if (clase === 0) {
          if (body === "Allow") {
            message = "Su voto fue emitido correctamente a favor de " + candidateName
          } else if (body === "Uninitiated") {
            message = "Su voto a favor de " + candidateName + " no pudo ser emitido, la votación no ha iniciado."
          } else if (body === "Finalized") {
            message = "Su voto a favor de " + candidateName + " no pudo ser emitido, la votación ha finalizado."
          } else if (body === "Voted" && available > 0) {
            message = "Su voto a favor de " + candidateName + " ya fue emitido con anterioridad, no puede votar por el mismo candidato."
          } else if (body === "Voted" && available === 0) {
            message = "No cuentas con votos disponibles para esta categoría.";
          } else {
            message = "Su voto a favor de " + candidateName + " no pudo ser emitido"
          }
        } else if (clase === 1) {
          if (body === "Allow") {
            message = "Muchas gracias por su confirmación."
            //setAvailableVotesInforme(available);
          } else if (body === "Uninitiated") {
            message = "No se puede emitir su confirmación, la votación no ha iniciado."
          } else if (body === "Finalized") {
            message = "No se puede emitir su confirmación, la votación ha finalizado."
          } else if (body === "Voted" && available > 0) {
            message = "No se puede emitir su confirmación."
          } else if (body === "Voted" && available === 0) {
            message = "No cuentas con votos disponibles para esta categoría.";
          } else {
            message = "No se puede emitir su confirmación."
          }
        } else if (clase === 2) {
          if (body === "Allow") {
            message = "Muchas gracias por su voto."
            //setAvailableVotes(available);
          } else if (body === "Uninitiated") {
            message = "No se puede emitir su voto, la votación no ha iniciado."
          } else if (body === "Finalized") {
            message = "No se puede emitir su voto, la votación ha finalizado."
          } else if (body === "Voted" && available > 0) {
            message = "No se puede emitir su voto."
          } else if (body === "Voted" && available === 0) {
            message = "No cuentas con votos disponibles para esta categoría.";
          } else {
            message = "No se puede emitir su voto."
          }
        } else if (clase === 3) {
          if (body === "Allow") {
            message = "Muchas gracias por su confirmación."
            //setAvailableVotes(available);
          } else if (body === "Uninitiated") {
            message = "No se puede emitir su confirmación, la votación no ha iniciado."
          } else if (body === "Finalized") {
            message = "No se puede emitir su confirmación, la votación ha finalizado."
          } else if (body === "Voted" && available > 0) {
            message = "No se puede emitir su confirmación."
          } else if (body === "Voted" && available === 0) {
            message = "No cuentas con votos disponibles para esta categoría.";
          } else {
            message = "No se puede emitir su confirmación."
          }
        }


        return (
          <div className='custom-ui '>
            <h1>{message}</h1>
            <div className="button-container">
              <button className="button-modal center" onClick={onClose}>Regresar</button>
            </div>
          </div>
        );
      }
    });
  }

  return (
    <div>
      <HeaderCampana Cargarvotaciones={Cargarvotaciones}></HeaderCampana>
      <div className="main other-component" style={{ backgroundImage: "url(/Fondo5.png)" }}>
        <Welcome redirectTransmision={redirectTransmision}></Welcome>
        <div >
          <center><LoadingIndicator /></center>
          <ul className="cards" key="lista">
            {campanaEspecial.map((item, key) => (
              (item.flag === "Quorum") ? (
                <Quorum
                  texto={item.Opcion1[0].Descripcion}
                  estateVotesQuorum1={item.Opcion2[0].estado}
                  estateVotesQuorum2={item.Opcion1[0].estado}
                  availableVotesQuorum1={item.Opcion2[0].disponible}
                  availableVotesQuorum2={item.Opcion1[0].disponible}
                  voteNoConfirm={voteNoConfirm}
                  redirectTransmision={redirectTransmision}
                  idCampana1={item.Opcion2[0].IDCandidato}
                  idCampana2={item.Opcion1[0].IDCandidato}
                  id={key}
                  nombre={"Validación Quórum"}
                ></Quorum>
              ) : (item.flag === "Opcion1") ? (
                <li className="cards_item" >
                  <div className="card" style={{ backgroundImage: "url(/fondos/Fondo1.jpg)" }}>
                    <img src="./iconos/icono3.png" />
                    <h2 className="card_title">{item.Opcion[0].campana}</h2>
                    <center>
                      <Link className="button-small" to={"/candidatos/" + item.Opcion[0].IDCampana} id={item.Opcion[0].IDCampana}>Ver más</Link>
                    </center>
                  </div>
                </li>
              ) : (item.flag === "Opcion2") ? (
                <Opcion2
                  disponible={item.Opcion[0].disponible}
                  estado={item.Opcion[0].estado}
                  askForVote={askForVote}
                  nombre={item.Opcion[0].campana}
                  descripcion={item.Opcion[0].DescripcionCampana}
                  pregunta1={item.Opcion[0].Descripcion}
                  pregunta2={item.Opcion[1].Descripcion}
                  idCandidato1={item.Opcion[0].IDCandidato}
                  idCandidato2={item.Opcion[1].IDCandidato}
                  Opcion1={item.Opcion[0].Nombre}
                  Opcion2={item.Opcion[1].Nombre}
                  id={key}
                ></Opcion2>
              ) : (item.flag === "Opcion3") ? (
                <Opcion3
                  disponible={item.Opcion[0].disponible}
                  estado={item.Opcion[0].estado}
                  askForVote={askForVote}
                  nombre={item.Opcion[0].campana}
                  descripcion={item.Opcion[0].DescripcionCampana}
                  pregunta1={item.Opcion[0].Descripcion}
                  pregunta2={item.Opcion[1].Descripcion}
                  idCandidato1={item.Opcion[0].IDCandidato}
                  idCandidato2={item.Opcion[1].IDCandidato}
                  Opcion1={item.Opcion[0].Nombre}
                  Opcion2={item.Opcion[1].Nombre}
                  Foto={item.Opcion[0].Foto}
                  id={key}
                ></Opcion3>
              ) : (item.flag === "Opcion4") ? (
                <Opcion4
                  disponible={item.Opcion[0].disponible - 1}
                  estado={item.Opcion[0].estado}
                  askForKnow={askForKnow}
                  nombre={item.Opcion[0].campana}
                  descripcion={item.Opcion[0].Descripcion}
                  pregunta1={item.Opcion[0].Descripcion}
                  idCandidato1={item.Opcion[0].IDCandidato}
                  Opcion1={item.Opcion[0].Nombre}
                  id={key}
                ></Opcion4>
              ) : (item.flag === "Opcion6") ? (
                <li className="cards_item" key={item.Opcion[0].IDCampana + "ID" + key}>
                  <div className="card" style={{ backgroundImage: "url(/fondos/Fondo1.jpg)" }}>
                    <h2 className="card_title">{item.Opcion[0].campana}</h2>
                    <p className="card_text">{item.Opcion[0].DescripcionCampana}</p>
                    <center>
                      <Link className="button-small" to={"/candidatos/" + item.Opcion[0].IDCampana} id={item.Opcion[0].IDCampana}>Ver más</Link>
                    </center>
                  </div>
                </li>
              ) : (
                <li></li>
              )
            ))}
            {campaigns.map((campaign, key) =>
              (campaign.IDCampana > 12) ? (
                <li className="cards_item" key={campaign.IDCampana + "ID" + key}>
                  <div className="card" style={{ backgroundImage: "url(/fondos/Fondo1.jpg)" }}>
                    <h2 className="card_title">{campaign.Nombre}</h2>
                    <p className="card_text">{campaign.Descripcion}</p>
                    <center>
                      <Link className="button-small" to={"/candidatos/" + campaign.IDCampana} id={campaign.IDCampana}>Ver más</Link>
                    </center>
                  </div>
                </li>
              ) : (
                <></>
              )

            )}
          </ul>
        </div>

      </div>
    </div>

  )
}

export default CampanaInfo
